export const numberFormaterr = ({ numberInString }) => {
  if (numberInString === null) return "";
  let formatedTotalPopulation = "";

  for (let index = 0; index < numberInString.length; index++) {
    if (index % 3 === 0 && index <= numberInString.length - 2 && index > 0) {
      formatedTotalPopulation += ",";
    }
    formatedTotalPopulation += numberInString[index];
  }
  return formatedTotalPopulation;
};

export const numberFormater = ({ numberInString }) => {
  if (numberInString === null) return "";
  const len = numberInString.length;
  if (len < 4) return numberInString;
  let formatedTotalPopulation = "";
  for (let index = 0; index < numberInString.length; index++) {
    if((len - index) %3 === 0 && index > 0 && index < len)
    {
      
      formatedTotalPopulation += ",";

    }
    formatedTotalPopulation += numberInString[index];
  }
  return formatedTotalPopulation;
};
